define('glu/grid/filter/dateRangeSearch',['require','./fieldSearch','../../date','../../util','../../datePicker'],function(require) {
    'use strict';

    var FieldSearch = require('./fieldSearch'),
        date = require('../../date'),
        util = require('../../util'),
        DatePicker = require('../../datePicker');


    return FieldSearch.extend({
        className: 'date-range-search',
        today: new Date(), //saves execution in the filter method which gets called many times,
        startDate: null,
        endDate: null,

        ui: util.extend(FieldSearch.prototype.ui, {
            $dateInput: '.input-date'
        }),

        initialize: function() {
            this.filterDatePicker = this.createDatePicker();
            this.dateFormat = this.options.dateFormat || 'YYYY-MM-DD';
            this.listenTo(this, 'datePicked', this.handleSubmitButton);
        },

        onRender: function() {
            FieldSearch.prototype.onRender.apply(this, arguments);
            this.renderDatePicker();
        },

        renderDatePicker: function() {
            this.ui.$focusField.replaceWith(this.filterDatePicker.render().$el);
            this.$el.find('input').addClass('form-control')
                .attr({
                    id: 'field-value',
                    name: 'field-value'
                });
            this.bindUIElements();
            this.setValue();
        },

        setValue: function() {
            var value = this.model.get('value');

            if (!value) {
                return;
            }

            this.ui.$dateInput.val(value);
        },

        onClose: function() {
            if (this.filterDatePicker.view) {
                this.filterDatePicker.view.close();
            }
        },

        filter: function(field, value, model) {
            var modelDate = date(model.get(field), this.dateFormat),
                startMillis, endMillis, modelMillis;

            // if we don't have a dateElem we have never been rendered and probably have been restored from a serialized state
            // we need to get the datepicker code to recover the startDate and endDate from the value
            if (!this.filterDatePicker.dateElem) {
                this.filterDatePicker.dateElem = {
                    val: function() {
                        return value;
                    }
                };
                this.filterDatePicker.parseDateRange();

                // any errors and we don't get dates and the comparison below will just let everything match
                if (!this.filterDatePicker.hasError) {
                    this.startDate = this.filterDatePicker.startDate;
                    this.endDate = this.filterDatePicker.endDate || this.filterDatePicker.startDate;
                }
            }

            // convert everything to milliseconds for simple math comparison vs moment calls which are both more verbose and much slower
            // due to internal cloning
            startMillis = this.startDate ? this.startDate.valueOf() : undefined;
            endMillis = this.endDate ? this.endDate.valueOf() : undefined;
            modelMillis = modelDate ? modelDate.valueOf() : undefined;

            // if we don't have a startDate then we have no filter so let everything match
            return (!startMillis || (modelMillis >= startMillis && modelMillis <= endMillis));
        },

        // Creates the date picker to be used for filtering grid data
        createDatePicker: function() {
            var options = {
                labelText: '',
                imgAltText: '',
                endDate: this.endDate,
                startDate: this.startDate,
                eventTarget: this
            };

            if (this.model && this.model.has('dateFormat')) {
                options.dateFormat = this.model.get('dateFormat');
            }

            return new DatePicker(options);
        },

        onDatePicked: function(datePicker, startDate, endDate) {
            this.startDate = startDate;
            this.endDate = endDate || startDate;
        },

        handleSubmitButton: function() {
            var selection = FieldSearch.prototype.handleSubmitButton.apply(this, arguments);

            if (!selection || !this.filterDatePicker.dateElem) {
                return;
            }

            this.filterDatePicker.processDateInput();
            this.ui.$submitBtn.prop('disabled', this.filterDatePicker.hasError);
            this.ui.$clearBtn.toggleClass('hidden', this.filterDatePicker.hasError);
        }
    });
});

